import React from "react";
import { withTranslation } from "react-i18next";
import withRouter from "../../HOC/withRouter";
import Modal from "react-modal";
import DailyQuestContainer from "./DailyQuestContainer";
import "./styles.scss";

Modal.setAppElement("#root");
const DailyQuestModal = ({ quest, questModalVisible, closeModal, showQuestAnimation, answerQuest, client }) => {
  return (
    <div className="notifications-container">
      <Modal
        isOpen={questModalVisible}
        onRequestClose={closeModal}
        className="quest-modal-wrapper brandification-modal-base"
        contentLabel="Daily Quest Modal"
      >
        <div className="quest-modal">
          <DailyQuestContainer
            quest={quest}
            closeModal={closeModal}
            showQuestAnimation={showQuestAnimation}
            answerQuest={answerQuest}
            client={client}
          />
        </div>
      </Modal>
    </div>
  );
};

export default withRouter(withTranslation()(DailyQuestModal));
